import './general-observations-area.scss'

import { FormApi } from 'final-form';
import { get } from 'lodash';
import Component from 'vue-class-component';

import { ReportFeatured } from '@skinsoft/entity-ui';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EnhancedTextArea, ThesaurusTermChooser, ThesaurusTermChooserList } from '@skinsoft/ui';

@Component({
    components: {
        sEnhancedTextArea: EnhancedTextArea,
        sThesaurusTermChooser: ThesaurusTermChooser,
        sThesaurusTermChooserList: ThesaurusTermChooserList
    },
    props: ["reportFeatured", "form", "fieldName"],
    template: require('./general-observations-area.html')
})
export class GeneralObservationsArea extends ReactiveVue {

    public reportFeatured: ReportFeatured;
    public fieldName: string;
    public form: FormApi;

    public get observationsFieldName() {
        return `${this.fieldName}.conditionReportCS.comments[0.translatedString.${this.$i18n.locale}`
    }

    public get interventionsToScheduleFieldName() {
        return `${this.fieldName}.conditionReportCS.predictInterventions`
    }

    public get treatmentPriorityFieldName() {
        return `${this.fieldName}.conditionReportCS.treatmentPriority`
    }

    public get stateOfConservationFieldName() {
        return `${this.fieldName}.conditionReportCS.stateOfConservations`
    }

    public get interventionsToSchedule() {
        return get(this.form.getState().values, `${this.fieldName}.conditionReportCS.predictInterventions`)
    }

    public get precisionSubPath() {
        return `precision.translatedString.${this.$i18n.locale}`
    }

}